import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const slugArray = to.params.slug as string[]
  const lastSegment = slugArray?.at(-1)

  const isBrandPage =
    lastSegment === 'brands' || lastSegment?.endsWith('-brands')

  if (isBrandPage) {
    to.meta.pageType = 'all_brand_page'
    to.meta.contentType = 'Brand Page'
    to.meta.SnPageType = 'brand'
  } else {
    to.meta.pageType = 'content_pages'
    to.meta.contentType = 'Static Content Page'
    to.meta.SnPageType = 'other'
  }
})
